import { Component, OnInit } from '@angular/core';
import { UsuariosService } from '../../../services/usuarios.service';
import { FuncionalidadesService } from '../../../services/funcionalidades.service';
import { UsuarioRolesService } from '../../../services/usuario-roles.service';
import { FuncionalidadRolesService } from '../../../services/funcionalidad-roles.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import * as $ from 'jquery';

@Component({
  selector: 'app-asig-func-rol-usu',
  templateUrl: './asig-func-rol-usu.component.html',
  styleUrls: ['./asig-func-rol-usu.component.css']
})
export class AsigFuncRolUsuComponent implements OnInit {

  titulo = 'Asignación de funcionalidades y roles a usuarios';

  pagina = 1;


  indiceRolOrigen: any;
  indiceRolDestino: any;
  respuesta:any
  usuarios:any
  listUsuarios:any=[]
  cadena:string[]=[]
  cadenaUsuario:string[]=[]
  cadenaDestino:string[]=[]
  listAplicaciones:any=[]
  listAplicacionesDestino:any=[]
  aplicacionOrigen:any
  aplicacionDestino:any
  indiceAplicacionOrigen:string=''
  indiceAplicacionDestino:string=''
  indexAplicacionDestino:number=-1
  usuarioAplicacionRol:any
  respuestaUsuarios:any=[]

  cadenaRolDestino:string[]=[]
  listRoles:any=[]
  /**
   * lista con la relacion de roles por aplicacion que se va a guardar
   */
  listAplicationRolesToSave:any[]=[];

  /**
   * lista de las aplicaciones a las que se le asignada un rol
   */
  listRolesDestino:any=[]
  rolOrigen:any
  rolDestino:any
  indexRolDestino:number=-1

  codigo:string | undefined = ''
  editar:boolean=false
  usuario:any = {
    idUsuario:'',
    nombreUsuario:'',
    email:'',
    perfil:'',
    area:''
  }

  constructor(private usuariosService: UsuariosService,
              private funcionalidadesService: FuncionalidadesService,
              private usuarioRolesService: UsuarioRolesService,
              private funcionalidadRolesService: FuncionalidadRolesService,
              private router: Router,
              private route: ActivatedRoute
              )
  {
    this.codigo = this.route.snapshot.paramMap.get('id')?.toString();

  }

  ngOnInit(): void {

    $("#cancelFunc").on("click", () => {
      $("#cajaFunc").val('');
    });

    $("#cancelRol").on("click", () => {
      $("#cajaRol").val('');
    });
    this.cargarAplicaciones()


  }

  traerUsuarioById():void{
    this.usuariosService.traerUsuarioById(this.codigo+"")
    .subscribe(resp => {
      this.respuesta = resp;
      this.usuario = {
        idUsuario : this.respuesta.data[0].idUsuario,
        nombreUsuario:this.respuesta.data[0].nombreUsuario,
        email:this.respuesta.data[0].email,
        perfil:this.respuesta.data[0].perfil,
        area:this.respuesta.data[0].area
      }
      this.traerAplicacionRolesUsuario()
    });
  }

  traerAplicacionRolesUsuario():void{
    let data:any = this.respuesta.data
    let aplicacion:any=[]

    this.listAplicacionesDestino=[]
    data.forEach((item: { idAplicativo: string; nombreAplicativo: string; idRol:string; nombreRol:string}) => {

      aplicacion={
        idAplicativo: '',
        nombreAplicativo: '',
        idRol:'',
        nombreRol:''
      }

      aplicacion.idAplicativo = item.idAplicativo
      aplicacion.nombreAplicativo = item.nombreAplicativo
      aplicacion.idRol = item.idRol
      aplicacion.nombreRol = item.nombreRol

      this.cadenaDestino.push(aplicacion.idAplicativo);
      this.listAplicacionesDestino.push(aplicacion)

    });

  }

  buscar(texto: string): void{
    this.usuariosService.traerUsuario(texto)
    .subscribe(resp => {
      this.respuesta = resp;
      this.respuestaUsuarios = this.respuesta.data
      this.quitarDuplicados()
    });
  }

  quitarDuplicados(){
    let usuario:any
    this.cadenaUsuario =[]
    this.usuarios = []
    this.respuestaUsuarios.forEach((data: {
      idUsuario: string;
      nombreUsuario:string;
      email:string;
      perfil:string;
      area:string
    }) => {
    usuario={
      idUsuario:'',
      nombreUsuario:'',
      email:'',
      perfil:'',
      area:''
    }
    usuario.idUsuario = data.idUsuario
    usuario.nombreUsuario = data.nombreUsuario
    usuario.email=data.email
    usuario.perfil = data.perfil
    usuario.area = data.area
    if (!this.cadenaUsuario.includes(data.idUsuario)) {
      this.usuarios.push(usuario);
      this.cadenaUsuario.push(data.idUsuario);
    }
   });
  }


  borrar(){
    this.usuarios = []
  }

  addUsuario(usuario:any){
    if (!this.cadena.includes(usuario.idUsuario)) {
      this.listUsuarios.push(usuario);
      this.cadena.push(usuario.idUsuario);
    }
  }

  quitarUsuario(item: number): void{
    this.listUsuarios.splice(item, 1);
  }

  cargarAplicaciones():void{
    this.funcionalidadRolesService.traerFuncionalidadRoles()
    .subscribe(resp => {
      this.respuesta = resp;
      this.listAplicaciones = this.respuesta.data;

      this.listAplicacionesDestino = [];
      if(this.codigo != undefined){
        this.titulo = 'Editar funcionalidades y roles de usuarios'
        this.editar = true
        this.traerUsuarioById()

      }
    });
  }

  seleccionarAplicacionOrigen(e:any, i:number){
    this.aplicacionOrigen = this.listAplicaciones[i]
    this.indiceAplicacionOrigen = this.listAplicaciones[i].idAplicativo;

  }

  seleccionarAplicacionDestino(e:any, i:number){
    let rol:any=undefined


    this.aplicacionDestino = this.listAplicacionesDestino[i];
    this.indiceAplicacionDestino = this.listAplicacionesDestino[i].idAplicativo
    this.indexAplicacionDestino = i
    this.listRoles = []
    this.listRolesDestino = []
    console.log(this.codigo )
    if (this.codigo != undefined){
      rol={
        idRol:'',
        nombreRol:'',
        idaplicativo:''
      }
      rol.idRol = this.aplicacionDestino.idRol
      rol.nombreRol = this.aplicacionDestino.nombreRol
      rol.idaplicativo=this.aplicacionDestino.idAplicativo
      console.log(rol);
      console.log(this.listAplicationRolesToSave);

        let filteredItems = this.listAplicationRolesToSave.filter((item: { idAplicativo: string; }) => item.idAplicativo==this.indiceAplicacionDestino);
      console.log(filteredItems);

        if(filteredItems.length==0 && rol.idRol!=null && rol.idRol!=undefined)
        {
            this.listRolesDestino.push(rol)
        }
        else
        {
          if(filteredItems.length!=0)
          {
            if(filteredItems[0].roles[0]!=undefined && filteredItems[0].roles[0]!=null )
            {
              rol.idRol = this.aplicacionDestino.idRol
              rol.nombreRol = filteredItems[0].roles[0].nombreRol
              this.listRolesDestino.push(rol)

            }
          }

        }



      this.funcionalidadRolesService.traerFuncionalidadRolesById(this.aplicacionDestino.idAplicativo)
      .subscribe(resp =>{
        this.respuesta = resp
        this.aplicacionDestino.idRoles = this.respuesta.data[0].idRoles
        this.aplicacionDestino.roles = this.respuesta.data[0].roles
        if(this.aplicacionDestino.roles!=null )
          this.cargarRolesAplicacion()
      });
    }else if(this.aplicacionDestino.roles!=null )
        this.cargarRolesAplicacion()

  }

  agregarAplicacion(){
    if (this.aplicacionOrigen != undefined) {
      console.log(this.cadenaDestino)
      console.log(this.aplicacionOrigen.idAplicativo);
      if (!this.cadenaDestino.includes(this.aplicacionOrigen.idAplicativo)) {

        this.listAplicacionesDestino.push(this.aplicacionOrigen);
        this.cadenaDestino.push(this.aplicacionOrigen.idAplicativo);
      }

      this.indiceAplicacionOrigen = '';
      this.aplicacionOrigen = undefined;
    }
  }
  quitarAplicacion(){
    if (this.aplicacionDestino != undefined) {

      let idaplicativo= this.listAplicacionesDestino[this.indexAplicacionDestino].idAplicativo;
      console.log(idaplicativo);
      console.log(this.listRoles);
      console.log(this.listRolesDestino);
      if(this.listRoles.length!=0)
      {
        if(this.listRoles[0].idaplicativo==idaplicativo)
        {
          this.listRoles=[];
        }
      }
      if(this.listRolesDestino.length!=0)
      {
        if(this.listRolesDestino[0].idaplicativo==idaplicativo)
        {
          this.listRolesDestino=[];
        }
      }
      console.log(this.listRoles);
      console.log(this.listRolesDestino);
      this.listAplicacionesDestino.splice(this.indexAplicacionDestino,1);
      this.cadenaDestino.splice(this.indexAplicacionDestino,1)
      this.indiceAplicacionDestino = '';
      this.aplicacionDestino = undefined;


    }
  }

  cargarRolesAplicacion(){
    let nombreRoles:string[]=[]
    let rol: any
    nombreRoles = this.aplicacionDestino.roles.split(',')
    for(let i=0; i<this.aplicacionDestino.idRoles.length; i++){
      rol = {
        idRol:'',
        nombreRol:'',
        idaplicativo:''
      }
      rol.idRol = this.aplicacionDestino.idRoles[i]
      rol.nombreRol = nombreRoles[i]
      rol.idaplicativo=this.aplicacionDestino.idAplicativo
      this.listRoles.push(rol)
    }
  }

  seleccionarRolOrigen(e:any, i:number){
  this.rolOrigen = this.listRoles[i]
  this.indiceRolOrigen = this.listRoles[i].idRol;
}

  seleccionarRolDestino(e:any, i:number){
    this.rolDestino = this.listRolesDestino[i];
    this.indiceRolDestino = this.listRolesDestino[i].idRol
    this.indexRolDestino = i
  }

  agregarRol(){


    if (this.rolOrigen != undefined) {

        this.cadenaRolDestino.push(this.rolOrigen.idRol);
        if(this.listRolesDestino.length==0)
        {

          this.listRolesDestino.push(this.rolOrigen);
        }
        else
        {
          this.ventanaEmergenteError('Solo se puede seleccionar un rol por aplicación');
        }




      let found=false;

      this.listAplicationRolesToSave.forEach((data:any) => {

        if(data.idAplicativo==this.aplicacionDestino.idAplicativo)
        {
          data.roles=this.listRolesDestino
          found=true;
        }
      });

      if(this.listAplicationRolesToSave.length==0 || !found)
      {
        this.listAplicationRolesToSave.push(
          {
            idAplicativo:this.aplicacionDestino.idAplicativo,
            nombreAplicativo:this.aplicacionDestino.nombreAplicativo,
            roles:this.listRolesDestino
          }
        )
      }


      this.indiceRolOrigen = '';
      this.rolOrigen = undefined;
    }
  }
  quitarRol(){
    if (this.rolDestino != undefined) {
      this.listRolesDestino.splice(this.indexRolDestino,1);
      this.cadenaRolDestino.splice(this.indexRolDestino,1)
      this.indiceRolDestino = '';


      this.listAplicationRolesToSave.forEach((data:any, index: number) => {

        if(data.idAplicativo==this.aplicacionDestino.idAplicativo)
        {
          data.roles=this.listRolesDestino

        }

      });


    }
  }
  cancelar(){
    this.router.navigateByUrl('principal');
  }
  guardar(){
    this.usuarioAplicacionRol=[];
    if(this.codigo != undefined)
    {
      this.listUsuarios.push(
        {
          nombre:"",
          idUsuario:this.codigo
        }
      )
    }

    if(this.listAplicationRolesToSave.length>0){
      this.listUsuarios.forEach((data: { idUsuario: string; }) => {


        this.listAplicationRolesToSave.forEach((data2:any) => {

          data2.roles.forEach((value: { idRol: any; }) =>
          {
            this.usuarioAplicacionRol.push(
              {
                idAplicativo:data2.idAplicativo,
                idRole:value.idRol,
                idUsuario:data.idUsuario
              }
            )
          })

        });



      });

      this.usuariosService.guardarAplicativoRolUsuario(this.usuarioAplicacionRol)
      .subscribe(resp => {
        if (resp.data!=null) {
          this.ventanaEmergenteExito();
          this.router.navigateByUrl('principal');
        } else {
          this.ventanaEmergenteError('No se pudo hacer la asignación de aplicaciones y roles seleccionados');
        }
      });
    }else{
        this.ventanaEmergenteError('Debe de añadirse almenos un rol para guardar');
    }
  }
  ventanaEmergenteError(mensaje: string): void{
    Swal.fire({
      title: 'Operación no exitosa',
      text: `${ mensaje }`,
      iconHtml: '<img src="assets/img/error.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-danger'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }

  ventanaEmergenteExito(): void{
    Swal.fire({
      title: 'Operación exitosa',
      iconHtml: '<img src="assets/img/success.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-success'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }

}
